import { memo } from 'react';
import { Input, Text } from '@chakra-ui/react';
import { UseFormRegister } from 'react-hook-form';

import { Field } from '@/components/ui/field';
import { FormValues } from '../hooks/useSessionForm';

const ErrorMessage = ({ message }: { message?: string }) =>
  message ? (
    <div style={{ fontSize: '14px', color: 'var(--chakra-colors-error-700)' }} role="alert">
      {message}
    </div>
  ) : null;

interface SessionNameSectionProps {
  register: UseFormRegister<FormValues>;
  errors: Record<string, { message?: string }>;
  isSubmitting: boolean;
  isLoadingCandidate: boolean;
}

export const SessionNameSection: React.FC<SessionNameSectionProps> = memo(
  ({ register, errors, isSubmitting, isLoadingCandidate }) => (
    <Field
      label={
        <Text fontSize="16px" fontWeight="semibold">
          Session Name
        </Text>
      }
      invalid={!!errors.sessionName}
      errorText={<ErrorMessage message={errors.sessionName?.message} />}
    >
      <Input
        size="lg"
        borderRadius="8px"
        placeholder="Interview with John Doe"
        disabled={isSubmitting || isLoadingCandidate}
        _disabled={{
          bg: 'neutrals.300'
        }}
        {...register('sessionName')}
        aria-label="Meeting title"
      />
    </Field>
  )
);

SessionNameSection.displayName = 'SessionNameSection';
